import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ApplicationService } from '../application-service/application.service';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { TranslatePipe } from '@ngx-translate/core'; // tslint:disable-line
import { EulaService } from '../eula/eula.service';

@Component({
    selector: 'eula-popup',
    templateUrl: './eula.component.html',
    styleUrls: ['../../assets/theme/css/ConfirmDialog.css'],
    animations: [
        trigger('opening', [
            transition(':enter', [
                style({'opacity': 0}),
                animate('300ms', style({opacity: 1}))
            ])
        ])
    ]

})

export class EulaComponent {

    public get isEulaActive(): boolean {
        return this._eulaService.isEulaDisplayed();
    }

    constructor(
        public _application: ApplicationService,
        private _oxeModelService: OxeModelService,
        private _eulaService: EulaService
    ) { }

    public clickLogsLink() {
        this._oxeModelService.downloadLogs();
    }

    public onClosePopup(): void {
        this._eulaService.enableEulaDisplay(false);
    }

    public showVersion(): boolean {
        if (this._application.version != "0.0.0001")
            return true;
        else
            return false;
    }
}
